import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  static targets = ['deleteButton', 'buttonWrapper']

  connect() {
    this.checkboxes = document.querySelectorAll('.service-record-checkbox')
    
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => { this.validateSelection() })
    })

    setTimeout(() => { this.validateSelection() }, 100)
  }

  validateSelection() {
    if (!this.hasDeleteButtonTarget) { return }

    const selectedCheckboxes = Array.from(this.checkboxes).filter(cb => cb.checked)
    const protectedRecords = selectedCheckboxes.filter(cb => cb.dataset.protectedActivity === 'true')

    if (protectedRecords.length > 0) {
      this.disableButton(protectedRecords)
    } else if (selectedCheckboxes.length > 0) {
      this.enableButton()
    }
  }

  disableButton(protectedRecords) {
    const button = this.deleteButtonTarget

    button.classList.add('disabled')
    button.setAttribute('aria-disabled', 'true')
    button.style.pointerEvents = 'none'
    button.style.opacity = '0.65'
    button.style.cursor = 'not-allowed'

    const activityTypes = this.getUniqueActivityTypes(protectedRecords)
    const typesText = this.formatActivityTypes(activityTypes)

    const message = `You cannot currently delete service records connected to ${typesText} from here. ` +
              `If you want to continue with deleting service records, first remove these service records from your selection. ` +
              `To delete the ${typesText} service records, you must go to the individual ${typesText.toLowerCase()} pages.`

    this.updateTooltip(message)
  }

  enableButton() {
    const button = this.deleteButtonTarget

    button.classList.remove('disabled')
    button.removeAttribute('aria-disabled')
    button.style.pointerEvents = 'auto'
    button.style.opacity = ''
    button.style.cursor = ''

    this.removeTooltip()
  }

  getTooltipElement() {
    if (!this.hasButtonWrapperTarget) return null
    return this.buttonWrapperTarget.querySelector('[data-tooltip-target="tooltip"]') || this.buttonWrapperTarget
  }

  updateTooltip(message) {
    const tooltipElement = this.getTooltipElement()
    if (!tooltipElement) return

    const existingTooltip = Tooltip.getInstance(tooltipElement)
    if (existingTooltip) {
      existingTooltip.dispose()
    }

    tooltipElement.setAttribute('title', message)
    tooltipElement.setAttribute('data-bs-title', message)
    tooltipElement.setAttribute('data-bs-original-title', message)

    new Tooltip(tooltipElement, {
      trigger: 'hover focus',
      placement: 'top'
    })
  }

  removeTooltip() {
    const tooltipElement = this.getTooltipElement()
    if (!tooltipElement) return

    const existingTooltip = Tooltip.getInstance(tooltipElement)
    if (existingTooltip) {
      existingTooltip.dispose()
    }

    tooltipElement.removeAttribute('title')
    tooltipElement.removeAttribute('data-bs-title')
    tooltipElement.removeAttribute('data-bs-original-title')
  }

  getUniqueActivityTypes(protectedRecords) {
    const types = protectedRecords.map(cb => cb.dataset.activityType)
    return [...new Set(types)].filter(Boolean)
  }

  formatActivityTypes(types) {
    if (types.length === 0) return 'protected activities'
    if (types.length === 1) return types[0]
    if (types.length === 2) return `${types[0]} and ${types[1]}`

    const lastType = types[types.length - 1]
    const otherTypes = types.slice(0, -1).join(', ')
    return `${otherTypes}, and ${lastType}`
  }
}
